import Vue from 'vue'
import {adminRoles, UserRoleEnum} from '@/enums/userRolesEnum'
import { BallPulseLoader } from 'vue-loaders';
import ProviderOwner from './providerComponents/ProviderOwner.vue'
import ProviderStatus from './providerComponents/ProviderStatus.vue'
import FacilityCredentialsCard from './cards/facilityCredentials/FacilityCredentialsCard'
import StateLicensesCard from './cards/stateLicenses/StateLicensesCard'
import ProviderCertificationsCard from './cards/certifications/CertificationsCard'
import DEALicensesCard from './cards/deaLicense/DEALicenseCard'
import ProviderSpecialtiesCard from './cards/specialties/ProviderSpecialtiesCard'
import ProviderDocumentsCard from './cards/documents/ProviderDocumentsCard'
import GeneralInformationCard from './cards/generalInformation/GeneralInformationCard'
import AvailabilityCard from './cards/availability/AvailabilityCard'
import ProviderFinancialCard from './cards/financial/ProviderFinancialCard';
import ProviderEducationItems from "@/components/provider/cards/education/ProviderEducationItems";
import ProviderEcfmgItem from "@/components/provider/cards/education/ProviderEcfmgItem";
import ProviderWorkHistoryItems from "@/components/provider/cards/workhistory/ProviderWorkHistoryItems";
import ProviderTimeGapExplanationItems from "@/components/provider/cards/workhistory/ProviderTimeGapExplanationItems";
import ProviderReferenceItems from "@/components/provider/cards/reference/ProviderReferenceItems";
import ProviderCommunicationsCard from "@/components/provider/cards/communications/CommunicationsCard";
import {CredentialingSubEntityType} from "@/enums/CredentialingSubEntityType";
import FacilityCredentialingDocumentFill
  from "@/components/provider/cards/facilitycredentialingdocuments/FacilityCredentialingDocumentFill";
import EmailHistory from "@/components/communications/history/EmailHistory";
import NotesCard from "@/componentsReusable/cards/NotesCard";
import {AppEntityType} from "@/enums/AppEntityType";

export default Vue.extend({
  name: 'Provider',
  props: {
    'new-provider': { type: Boolean, default: false},
    'providerId': { type: [String, Number], required: false},
  },
  data () {
    return {
      cardExpanded: true,
      UserRoleEnum: UserRoleEnum,
      isAuthorized: false,
      loadingInitialData: false,
      providerFullName: '...',
      loadingProviderName: false,
      providerName: '',
      CredentialingSubEntityType: CredentialingSubEntityType,
      noteEntityType: AppEntityType.PROVIDER_NOTE,
    }
  },
  components: {
    BallPulseLoader,
    ProviderOwner,
    ProviderStatus,
    FacilityCredentialsCard,
    GeneralInformationCard,
    StateLicensesCard,
    ProviderCertificationsCard,
    DEALicensesCard,
    NotesCard,
    ProviderSpecialtiesCard,
    ProviderDocumentsCard,
    AvailabilityCard,
    ProviderFinancialCard,
    ProviderEducationItems,
    ProviderEcfmgItem,
    ProviderWorkHistoryItems,
    ProviderTimeGapExplanationItems,
    ProviderReferenceItems,
    FacilityCredentialingDocumentFill,
    ProviderCommunicationsCard,
    EmailHistory
  },
  computed: {
    isAuthorizedforAccounting (): boolean {
      return this.$store.getters['user/hasRole']([
        UserRoleEnum.MANAGER,
        UserRoleEnum.ACCOUNTANT
      ]);
    },
    isProviderUser (): boolean {
      return this.$store.getters['user/hasOnlyRole'](UserRoleEnum.PROVIDER);
    }
  },
  beforeMount: function () {
    this.isAuthorized = this.$store.getters['user/hasRole']([...adminRoles, UserRoleEnum.PROVIDER]);
  },
  methods: {
    providerLoaded(providerInfo: any) {
      if (!this.isProviderUser || !providerInfo) {
        return;
      }
      this.providerName = providerInfo.firstName + ' ' + providerInfo.lastName + ' | ' + providerInfo.title;
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/provider/Provider.ts